import {DEFAULT_COLOR_SCALE} from './colors';
import {useEffect} from 'react';
import {useLoading} from 'common/hooks/map-hooks';

const MAX_ZOOM = 23;
const MIN_ZOOM = 13;
const OPACITY_LEVEL = 0.8;

export const scaleValues = (
  legendMinValue,
  legendMaxValue,
  legendColorScale = DEFAULT_COLOR_SCALE,
) => {
  const scaleRange = legendMaxValue - legendMinValue;
  const scaleUnit = scaleRange / legendColorScale.length;
  return legendColorScale.map(
    (color, index) =>
      legendMinValue + Math.round(scaleUnit * (index + 1) * 10) / 10,
  );
};

const addLayers = (map, options) => {
  const colors = [];
  scaleValues(0, 1, options.legendColorScale).forEach((value, index) => {
    colors.push(value);
    colors.push(options.legendColorScale[index]);
  });
  const {geojsonUrl, legendMaxValue, legendMinValue} = options;

  map.addSource('visitors', {
    type: 'geojson',
    data: geojsonUrl,
  });
  map.addLayer({
    id: 'visitors-heat',
    type: 'heatmap',
    source: 'visitors',
    minzoom: MIN_ZOOM,
    maxzoom: MAX_ZOOM,
    paint: {
      'heatmap-intensity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        MIN_ZOOM,
        0.2,
        MAX_ZOOM,
        1,
      ],
      'heatmap-weight': [
        'interpolate',
        ['linear'],
        ['get', 'weight'],
        legendMinValue,
        0,
        legendMaxValue,
        1,
      ],
      'heatmap-color': [
        'interpolate',
        ['linear'],
        ['heatmap-density'],
        0,
        'transparent',
        ...colors,
      ],
      'heatmap-radius': [
        'interpolate',
        ['linear'],
        ['zoom'],
        1,
        1,
        13,
        1,
        15,
        2,
        16,
        4,
        17,
        7,
        18,
        13,
        19,
        25,
        20,
        45,
        21,
        80,
        22,
        150,
        23,
        300,
      ],
      'heatmap-opacity': OPACITY_LEVEL,
    },
  });
};

export const useHeatMapLayer = (map, loaded, options, dependencies = []) => {
  const loading = useLoading('heat', map, ['visitors-heat'], ['visitors']);
  useEffect(() => {
    if (map && loaded) {
      addLayers(map, options);
    }
    return () => {
      if (!map) {
        return;
      }
      if (map.getLayer('visitors-heat')) {
        map.removeLayer('visitors-heat');
      }
      if (map.getSource('visitors')) {
        map.removeSource('visitors');
      }
    };
  }, dependencies);
  return options.forExport ? false : loading;
};
